import { inject, InjectionToken } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

export const FORM_ERRORS = new InjectionToken('FORM_ERRORS', {
  providedIn: 'root',
  factory(): any {
    const translocoSvc = inject(TranslocoService);
    return {
      required: () => translocoSvc.translate('required'),
      maxNumber: (max: string) => translocoSvc.translate('numberGreater', {value: max}),
      minNumber: (min: string) => translocoSvc.translate('numberLower', {value: min}),
      invalidEmail: (error: any) => translocoSvc.translate(error),
      invalidDecimal: (error: any) => translocoSvc.translate(error)
    };
  }
});
